exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/custom_qpe_datatable.css"), "");

// Module
exports.push([module.id, "\r\n", ""]);

